import { defineComponent as _defineComponent } from 'vue';
import { ref, watch } from 'vue';
import axios from 'axios';
import { useI18n } from 'vue-i18n';
import { Dialog, DialogPanel, DialogTitle, TransitionRoot } from '@headlessui/vue';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import LoadingError from '@/components/LoadingError.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AlloyDialog',
    props: {
        isOpen: { type: Boolean, required: true },
        query: { type: Object, required: false }
    },
    emits: ['close'],
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const { t: $t } = useI18n();
        const alloyData = ref(null);
        const isLoading = ref(false);
        const error = ref(null);
        async function fetchAlloyHistory() {
            if (!__props.isOpen || !__props.query) {
                return;
            }
            alloyData.value = null;
            isLoading.value = true;
            error.value = null;
            try {
                const [year, month] = __props.query.to.split('-').map(Number);
                const date = new Date(year, month - 1);
                if (isNaN(date.getTime())) {
                    throw new Error($t('Invalid to date'));
                }
                date.setMonth(date.getMonth() - 35);
                let from = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
                if (date.toISOString().slice(0, 7) < '2000-01') {
                    from = '2000-01';
                }
                const response = await axios.get(`${settings.siteAddress}/app/api/alloy-surcharges-history.php`, {
                    params: {
                        from,
                        to: __props.query.to,
                        index: __props.query.alloy,
                        prefix: __props.query.prefix,
                        language: settings.languageCode.charAt(0).toUpperCase(),
                    },
                });
                const alloyHistory = response.data;
                if (alloyHistory.success) {
                    const newSurcharges = [];
                    for (const surcharges of alloyHistory.surcharges) {
                        const newSurcharge = {
                            head: (__props.query.prefix + ' ' + surcharges.title + ' ' + surcharges.unit).replace(/ /g, '\u00A0'),
                            body: {
                                rows: [],
                            },
                        };
                        let monthIndex = 0;
                        const values = surcharges.values;
                        const filteredValues = values.filter((value) => value !== null);
                        let normalizedValues = [];
                        if (filteredValues.length === 0) {
                            normalizedValues = values.map(() => null);
                        }
                        else {
                            const maxValue = Math.max(...filteredValues);
                            if (maxValue) {
                                normalizedValues = values.map((value) => value === null ? null : (value / maxValue) * 100);
                            }
                        }
                        for (const value of surcharges.values) {
                            newSurcharge.body.rows.push([
                                (value?.toString() || '').toString().split('').join('\n'),
                                {
                                    backgroundColor: normalizedValues[monthIndex] ? '#0073c6' : 'transparent',
                                    height: normalizedValues[monthIndex] ? `${normalizedValues[monthIndex]}px` : '',
                                },
                                alloyHistory.months[monthIndex].split('').join('\n'),
                            ]);
                            monthIndex++;
                        }
                        newSurcharges.push(newSurcharge);
                    }
                    alloyData.value = newSurcharges;
                }
                else {
                    error.value = $t('No data found.');
                }
            }
            catch (e) {
                error.value = e.response?.data?.message || $t('Could not alloy surcharge. Please try again.');
            }
            finally {
                isLoading.value = false;
            }
        }
        watch(() => [__props.isOpen, __props.query], fetchAlloyHistory);
        const emit = __emit;
        const __returned__ = { $t, alloyData, isLoading, error, fetchAlloyHistory, emit, get Dialog() { return Dialog; }, get DialogPanel() { return DialogPanel; }, get DialogTitle() { return DialogTitle; }, get TransitionRoot() { return TransitionRoot; }, LoadingSpinner, LoadingError };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
